// extracted by mini-css-extract-plugin
export default {"language-select":"LanguageOptions_language-select__VAZxt","language-select__title":"LanguageOptions_language-select__title__2n1iM"};